import React, { useState } from "react";
import { Box } from "@mui/system";
import { makeStyles } from "@mui/styles";
import placeholder from "../../images/video-placeholder.png";

const useStyles = makeStyles((theme) => ({
  magnifierImg: {
    width: "100%",
    height: "auto",
  },
  magnifierImage: {
    width: "280px",
    height: "280px",
    border: "2px solid #fff",
    zIndex: "10",
  },
}));

const ImageMagnifier = ({ imageUrl }) => {
  const classes = useStyles();
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  const handleMouseHover = (e) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();

    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;

    setPosition({ x, y });

    setCursorPosition({
      x: e.pageX - left,
      y: e.pageY - top,
    });
  };

  return (
    <Box
      sx={{
        position: "relative",
        "&:hover .magnifier-image": {
          backgroundPosition: `${position.x}% ${position.y}%`,
        },
      }}
      onMouseEnter={() => setShowMagnifier(true)}
      onMouseLeave={() => setShowMagnifier(false)}
      onMouseMove={handleMouseHover}
    >
      <img
        className={classes.magnifierImg}
        src={imageUrl}
        alt="original"
        onError={(e) => {
          e.target.src = placeholder;
        }}
      />

      {showMagnifier && (
        <div
          style={{
            position: "absolute",
            left: `${cursorPosition.x - 100}px`,
            top: `${cursorPosition.y - 100}px`,
            pointerEvents: "none",
            zIndex: "10",
          }}
        >
          <div
            className={classes.magnifierImage}
            style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundPosition: `${position.x}% ${position.y}%`,
            }}
          ></div>
        </div>
      )}
    </Box>
  );
};

export default ImageMagnifier;
